import { LocationApiService, PlanApiService, PropertyApiService } from '@admin/core';
import { HealthStatus } from '@admin/core/models';
import { HealthValues, SyncValues, TagStatusValues } from '@admin/shared/data';
import { personnelArrayToString } from '@admin/shared/helpers/utility.helper';
import { Component, inject } from '@angular/core';
import { CacBaseDialogComponent, CacDialogLayoutComponent, CacTableComponent, table } from '@controladad/ng-base';

export type PropertyHistoryDialogData = number;
export type PropertyHistoryDialogResult = never;

@Component({
  selector: 'app-property-history-dialog',
  imports: [CacDialogLayoutComponent, CacTableComponent],
  templateUrl: './property-history-dialog.component.html',
})
export class PropertyHistoryDialogComponent extends CacBaseDialogComponent<
  PropertyHistoryDialogData,
  PropertyHistoryDialogResult
> {
  private readonly propertyApi = inject(PropertyApiService);
  private readonly locationApi = inject(LocationApiService);
  private readonly planApi = inject(PlanApiService);

  table = table({
    itemsFn: this.propertyApi.propertyHistoryAdapter(this.data),
    pagination: {
      size: 10,
    },
    columns: {
      locationName: {
        label: 'مکان',
        filterable: [
          {
            type: 'equal',
            controlType: 'select',
            items: this.locationApi.getLocationItems(),
            multiple: true,
            key: 'locationIds',
          },
        ],
      },
      personnel: {
        label: 'تحویل گیرنده',
        filterable: 'PersonnelSearch',
        transform: (v) => personnelArrayToString(v),
      },
      healthStatus: {
        label: 'وضعیت سلامت',
        type: 'tag',
        dynamicClass: (v) => (v === HealthStatus.Healthy ? 'text-green-700' : 'text-error-600'),
        items: HealthValues,
        filterable: [
          {
            key: 'healthStatuses',
            type: 'equal',
            controlType: 'select',
            items: HealthValues,
            multiple: true,
          },
        ],
      },
      tagStatus: {
        label: 'وضعیت تگ',
        type: 'tag',
        dynamicClass: (v) => (v ? 'text-green-700' : 'text-error-600'),
        items: TagStatusValues,
        filterable: [
          {
            key: 'tagStatuses',
            type: 'equal',
            controlType: 'select',
            items: TagStatusValues,
            multiple: true,
          },
        ],
      },
      planName: {
        label: 'برنامه',
        filterable: [
          {
            key: 'PlanIds',
            type: 'equal',
            controlType: 'select',
            items: this.planApi.getPlanItems(),
            multiple: true,
          },
        ],
      },
      managedDate: {
        label: 'تاریخ ثبت',
        type: 'datetime',
        filterable: [
          {
            type: 'greater',
            controlType: 'datetime',
            key: 'ManagedDateFrom',
          },
          {
            type: 'lower',
            controlType: 'datetime',
            key: 'ManagedDateTo',
          },
        ],
      },
      userName: {
        label: 'اموال گردان',
        filterable: true,
        transform: (_, row) => `${row.userFirstName ?? ''} ${row.userLastName ?? ''}`,
      },
      isSynced: {
        label: 'وضعیت سینک',
        type: 'tag',
        dynamicClass: (v) => (v ? 'text-green-700' : 'text-error-600'),
        items: SyncValues,
        filterable: [
          {
            type: 'equal',
            controlType: 'select',
            items: SyncValues,
            multiple: true,
          },
        ],
      },
    },
  });
}
